import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";

export class product_under_contr_cov_view extends entityBase {
  contr_line_type: KnockoutObservable<string>;
  contr_type: KnockoutObservable<string>;
  contract_id: KnockoutObservable<string>;
  contract_version: KnockoutObservable<number>;
  coverage_eff_dt: KnockoutObservable<Date>;
  formattedcoverage_eff_dt: any;
  coverage_end_dt: KnockoutObservable<Date>;
  formattedcoverage_end_dt: any;
  coverage_start_dt: KnockoutObservable<Date>;
  formattedcoverage_start_dt: any;
  line_status: KnockoutObservable<string>;
  sequence: KnockoutObservable<number>;
  contract_name: KnockoutObservable<string>;
  bill_to: KnockoutObservable<string>;
  constructor(item: any) {
    super();
    this.contr_line_type = ko.observable(item.contr_line_type).extend({ maxLength: 128 });
    this.contr_type = ko.observable(item.contr_type).extend({ maxLength: 32 });
    this.contract_id = ko.observable(item.contract_id).extend({ maxLength: 32 });
    this.contract_version = ko.observable(item.contract_version);
    this.coverage_eff_dt = ko.observable(this.formatJSONDate(item.coverage_eff_dt));
    this.formattedcoverage_eff_dt = CustomObservables.formattedDateTimeObservable(this.coverage_eff_dt);
    this.coverage_end_dt = ko.observable(this.formatJSONDate(item.coverage_end_dt));
    this.formattedcoverage_end_dt = CustomObservables.formattedDateTimeObservable(this.coverage_end_dt);
    this.coverage_start_dt = ko.observable(this.formatJSONDate(item.coverage_start_dt));
    this.formattedcoverage_start_dt = CustomObservables.formattedDateTimeObservable(this.coverage_start_dt);
    this.line_status = ko.observable(item.line_status).extend({ maxLength: 32 });
    this.sequence = ko.observable(item.sequence);
    this.contract_name = ko.observable(item?.contract?.contract_name);
    this.bill_to = ko.observable(item?.contract?.c_contract_places_view?.name1);
  }
}
